import React from 'react';
import {
    Edit,
    SimpleForm,
    TextInput,
    ReferenceInput,
    AutocompleteInput,
    BooleanInput,
    SelectInput,
    FormDataConsumer,
    useGetOne,
    Loading,
    Error,
    required,
    email,
    regex,
} from 'react-admin';
import {UserRoles} from '../common.js'
import {useParams} from "react-router-dom";
import { AdminUserRoles } from '../../../../constants/user.js';

const ClientEdit = (props) => {
    const { id } = useParams();
    const { data, isLoading, error } = useGetOne('admin_users', { id }, { staleTime: 60000 });

    if (isLoading) return <Loading />;
    if (error) return <Error />;

    return (
    <Edit {...props} redirect={"show"}>
            <SimpleForm >
                <TextInput source="name" validate={[required()]} />
                <TextInput source="surname" validate={[required()]} />
                <TextInput source="email" validate={[required(), email()]}  />
                <TextInput source="password" type="password" validate={[regex(/(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$€%^&*(),.?":{}|<>_-])(?=.{12,})/, 'La contraseña debe tener mínimo 12 caracteres y debe incluir una combinación de mayúsculas, minúsculas, números y caracteres especiales.')]}/>
                <BooleanInput source="force_reset_password" />
                <FormDataConsumer>
                    {// eslint-disable-next-line no-unused-vars
                        ({ formData }) => (
                            <>
                                <div className="child-items">
                                    <SelectInput source="admin_user.role" validate={[required()]} choices={UserRoles} />
                                </div>
                            </>
                        )}
                </FormDataConsumer>

                <FormDataConsumer>
                    {// eslint-disable-next-line no-unused-vars
                        ({ formData }) => (
                            formData.admin_user?.role &&
                            formData.admin_user.role !== AdminUserRoles.ROLE_ADMIN_ROOT &&
                            <>
                                <div className="child-items">
                                    <ReferenceInput
                                        source="client.id"
                                        reference="clients"
                                        sort={{field: 'name', order: 'ASC'}}
                                        perPage={1000}
                                    >
                                        <AutocompleteInput
                                            source="name"
                                            optionText="name"
                                            filterToQuery={(searchText) => ({ name: searchText})}
                                        />
                                    </ReferenceInput>
                                </div>
                            </>
                        )}
                </FormDataConsumer>
            </SimpleForm>
        </Edit>
    );
};

export default ClientEdit;
